import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {
  MeetingStatusRequest,
  MeetingStatusResponse,
  PageResponse,
} from '../models/meeting.model';

@Injectable({ providedIn: 'root' })
export class MeetingStatusApiService {
  private url = `${environment.apiUrl}api/meeting-statuses`;
  constructor(private http: HttpClient) {}

  list(
    businessId: number,
    page = 0,
    size = 20
  ): Observable<PageResponse<MeetingStatusResponse>> {
    const params = new HttpParams()
      .set('businessId', businessId.toString())
      .set('page', page.toString())
      .set('size', size.toString());
    return this.http.get<PageResponse<MeetingStatusResponse>>(this.url, { params });
  }

  listActive(businessId: number): Observable<MeetingStatusResponse[]> {
    const params = new HttpParams().set('businessId', businessId.toString());
    return this.http.get<MeetingStatusResponse[]>(`${this.url}/active`, { params });
  }

  getById(id: number, businessId: number): Observable<MeetingStatusResponse> {
    const params = new HttpParams().set('businessId', businessId.toString());
    return this.http.get<MeetingStatusResponse>(`${this.url}/${id}`, { params });
  }

  create(body: MeetingStatusRequest): Observable<MeetingStatusResponse> {
    return this.http.post<MeetingStatusResponse>(this.url, body);
  }

  update(
    id: number,
    body: MeetingStatusRequest
  ): Observable<MeetingStatusResponse> {
    return this.http.put<MeetingStatusResponse>(`${this.url}/${id}`, body);
  }

  delete(id: number, businessId: number): Observable<void> {
    const params = new HttpParams().set('businessId', businessId.toString());
    return this.http.delete<void>(`${this.url}/${id}`, { params });
  }
}
